/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import settlementCalculationTeaser from "../../../../assets/img/guidebook/Teaser_Abfindung-berechnen_700px.jpg";
import settlementProcedureTeaser from "../../../../assets/img/guidebook/Teaser_Abfindung-Ablauf_700px.jpg";
import settlementTaxTeaser from "../../../../assets/img/guidebook/Teaser_Abfindung-Steuer_350px.jpg";
import settlementCostTeaser from "../../../../assets/img/guidebook/Teaser_Abfindung-Kosten_350px.jpg";
import settlementKindsOfNoticesTeaser from "../../../../assets/img/guidebook/Teaser_Kuendigungsarten_350px.jpg";

const guidebookSettlementCalculation = {
  linkTo: "/ratgeber/arbeitsrecht/berechnung",
  image: settlementCalculationTeaser,
  headline: "Wie wird eine Abfindung berechnet?",
  text: "Ihnen wurde gekündigt und Sie fragen sich, ob Sie mit einer Abfindung rechnen können und wie hoch diese ausfallen wird? Wir erklären Ihnen in Kürze, ...",
  altTitle: "Abfindung berechnen",
};

const guidebookSettlementProcedure = {
  linkTo: "/ratgeber/arbeitsrecht/ablauf",
  image: settlementProcedureTeaser,
  headline: "Alles zum Ablauf nach einer Kündigung",
  text: "Wenn Ihnen gekündigt wurde, haben Sie die Möglichkeit, gegen die Kündigung zu klagen, um zum Beispiel eine Abfindung zu erhalten. Wie Sie sich jetzt verhalten sollten, ...",
  altTitle: "Abfindung berechnen",
};

const guidebookSettlementTax = {
  linkTo: "/ratgeber/arbeitsrecht/steuern",
  image: settlementTaxTeaser,
  headline: "Abfindung und Steuer",
  text: "Sie möchten eine Abfindung erhalten und im voraus wissen, ob diese steuerpflichtig ist? Sie haben keine Rechtsschutzversicherung und möchten erfahren, ob ...",
  altTitle: "Abfindung & Steuern",
};

const guidebookSettlementCosts = {
  linkTo: "/ratgeber/arbeitsrecht/kosten",
  image: settlementCostTeaser,
  headline: "Was kostet eine Kündigungsschutzklage?",
  text: "Das Wichtigste vorab: Auch ohne Rechtsschutzversicherung haben Sie bei uns kein Kostenrisiko! Legalbird übernimmt als Prozesskostenfinanzierer ...",
  altTitle: "Kosten Abfindung & Kündigung",
};

const guidebookKindsOfNotices = {
  linkTo: "/ratgeber/arbeitsrecht/kuendigungsarten",
  image: settlementKindsOfNoticesTeaser,
  headline: "Die Arten der Kündigung",
  text: "Sie haben eine Kündigung erhalten und fragen sich, um welche Art der Kündigung es sich handelt, und ob sie rechtswirksam ist? Wir erklären Ihnen, ...",
  altTitle: "Arten der Kündigung",
};

export {
  guidebookSettlementCalculation,
  guidebookSettlementProcedure,
  guidebookSettlementTax,
  guidebookSettlementCosts,
  guidebookKindsOfNotices,
};
